import {useSearchParams} from 'react-router-dom';

import {getCurrentYear} from 'presentation/utils/getCurrentYear';
import {useGetHistoryYearsQuery} from '../../../queries/useGetHistoryYearsQuery';
import {useGetObligationHistoryQuery} from '../queries/useGetObligationHistoryQuery';

function usePaymentsHistory() {
	const [searchParams, setSearchParams] = useSearchParams();
	const {data: availableYears = [], isLoading: isLoadingYears} = useGetHistoryYearsQuery({
		isShowCurrentYear: true,
	});

	const SEARCH_PARAMS = {
		year:
			searchParams.get('year') ||
			(availableYears[0]?.toString() ?? new Date().getFullYear().toString()),
	};

	const {year} = SEARCH_PARAMS;

	const {
		data: paymentsHistoryData,
		error,
		isLoading,
		refetch,
	} = useGetObligationHistoryQuery({year});

	const minDate = new Date(
		Number(availableYears[availableYears.length - 1] ?? new Date().getFullYear()),
		1,
		1,
	);
	const maxDate = new Date(Number(availableYears[0] ?? new Date().getFullYear()), 1, 1);
	const formattedYear = getCurrentYear({year, maxDate, minDate});

	const paymentsLoading = isLoading || isLoadingYears;
	const paymentsHasError = !!error;

	const isEmpty =
		!paymentsLoading && paymentsHistoryData ? paymentsHistoryData.length === 0 : false;

	const handleTryAgain = () => {
		const date = new Date();
		setSearchParams(prev => {
			prev.set('year', date.getFullYear().toString());
			return prev;
		});
		refetch();
	};

	return {
		SEARCH_PARAMS,
		setSearchParams,
		availableYears,
		paymentsHistoryData,
		formattedYear,
		paymentsLoading,
		paymentsHasError,
		handleTryAgain,
		isEmpty,
		minDate,
		maxDate,
	};
}

export {usePaymentsHistory};
